<template>
  <div class="table-search-root">
    <el-form
      ref="searchFormRef"
      class="table-search__form"
      size="small"
      label-width="120px"
      :model="formData"
      v-bind="formProps"
    >
      <!-- 查询表单模块 -->
      <el-row class="table-search__row" :gutter="gutter">
        <el-col
          v-for="(field, index) in fields"
          :key="field.name"
          class="table-search__col"
          :class="{'form__item--hidden': shouldCollapse(index)}"
          :xl="6"
          :lg="8"
          :md="12"
          :sm="24"
        >
          <el-form-item
            :label="field.label"
            :prop="field.name"
            :label-width="field.width"
          >
            <component
              :is="`el-${field.type}`"
              v-model.trim="formData[field.name]"
              v-bind="field.props"
              @change="handleChange"
              @keydown.enter.native="handleEnter"
            >
              <template v-if="field.type === FieldsType.SELECT">
                <el-option
                  v-for="option in field.options"
                  :key="typeof option.value === 'object'? String(option.value): option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </template>
            </component>
          </el-form-item>
        </el-col>

        <!-- 操作按钮模块 -->
        <div v-if="showOperationBtns" class="table-search__btns">
          <span
            v-if="showCollapseBtn"
            class="table-search__btn--filter ml-28"
            @click="toggleCollapse"
          >
            {{ isCollapse ? '展开' : '收起' }}
            <i :class="isCollapse ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" />
          </span>
          <slot name="button" />
          <el-button
            v-if="!hiddenResetBtn"
            :size="btnSize"
            @click="handleReset"
          >
            重置
          </el-button>
          <el-button
            type="primary"
            :size="btnSize"
            @click="handleSearch"
          >
            {{ searchText }}
          </el-button>
        </div>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import _ from 'lodash';
import searchFormFilter from './utils';

const FieldsType = {
  INPUT: 'input',
  SELECT: 'select',
};
// 不同尺寸所对应的页面宽度和每行 ElFormItem 个数
const DifferentSizeData = [
  { width: 1920, quantity: 4 }, // large
  { width: 1200, quantity: 3 }, // large
  { width: 992, quantity: 2 }, // middle
  { width: 768, quantity: 1 }, // small
  { width: 0, quantity: 1 }, // less than small
];
export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    formProps: {
      type: Object,
      default: () => ({}),
    },
    fields: {
      type: Array,
      default: () => [],
    },
    defaultCollapse: {
      type: Boolean,
      default: true,
    },
    showOperationBtns: {
      type: Boolean,
      default: true,
    },
    gutter: {
      type: Number,
      default: 10,
    },
    hiddenResetBtn: {
      type: Boolean,
      default: false,
    },
    isEnterEvent: {
      type: Boolean,
      default: false,
    },
    searchText: {
      type: String,
      default: '查询',
    },
    btnSize: {
      type: String,
      default: 'small',
    },
    showIndex: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      FieldsType,
      DifferentSizeData,
      isCollapse: this.defaultCollapse,
    };
  },
  computed: {
    showCollapseBtn() {
      const quantity = this.getPerLineItemQuantity();
      return this.fields.length >= quantity;
    },
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    shouldCollapse(index) {
      const quantity = this.getPerLineItemQuantity();
      return index > (quantity - this.showIndex) && this.isCollapse;
    },
    getPerLineItemQuantity() {
      const documentScrollWidth = document.documentElement.scrollWidth;
      const size = DifferentSizeData.find((item) => documentScrollWidth >= item.width);
      return size.quantity;
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    // eslint-disable-next-line func-names
    handleSearch: _.throttle(function () {
      const form = { ...this.formData };
      this.$emit('search', searchFormFilter(form));
    }, 1000),
    // eslint-disable-next-line func-names
    handleChange: _.throttle(function () {
      if (!this.isEnterEvent) {
        const form = { ...this.formData };
        this.$emit('search', searchFormFilter(form));
      }
    }, 1000),
    // eslint-disable-next-line func-names
    handleEnter: _.throttle(function () {
      if (this.isEnterEvent) {
        const form = { ...this.formData };
        this.$emit('search', searchFormFilter(form));
      }
    }, 1000),
    handleReset() {
      this.$refs.searchFormRef.resetFields();
      this.formData = {};
      this.$emit('reset', this.formData);
    },
  },
};
</script>

<style scoped lang="scss">
/**  查询表单模块样式  **/
.table-search__form {
  display: flex;
  flex-wrap: wrap;
}

.table-search__row {
  width: 100%;
}

.table-search__col:last-of-type {
  margin-bottom: 0;
}

::v-deep .el-select,
::v-deep .el-date-editor--daterange.el-input,
::v-deep .el-date-editor--daterange.el-input__inner,
::v-deep .el-date-editor--timerange.el-input,
::v-deep .el-date-editor--timerange.el-input__inner,
::v-deep .el-date-editor--datetimerange.el-input,
::v-deep .el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

::v-deep .el-date-editor--monthrange  {
  width: 100%;
}

::v-deep .el-date-editor .el-range-separator {
  width: auto;
}

.form__item--hidden {
  display: none;
}

/**  操作按钮模块样式  **/
.table-search__btns {
  margin-left: auto;
  margin-bottom: 16px;
  text-align: right;
}

.table-search__btn--filter {
  font-size: 12px;
  color: #606266;
  margin-right: 28px;

  &:hover {
    cursor: pointer;
  }

  [class*=" el-icon-"],
  [class^="el-icon-"] {
    color: #059E84 !important;
    font-family: "element-icons" !important;
  }
}

/**  功能样式  **/
.ml-28 {
  margin-left: 28px;
}

</style>
